import { css } from "@linaria/core";
import { Modal } from "antd";
import type { ReactNode } from "react";
import type { GenericIngredientFragment } from "../../../gql/generated/graphqlSchema.tsx";
import { IngredientSearch, type SearchItem, type SearchTab } from "./IngredientSearch.tsx";

export { type SearchItem, type SearchTab } from "./IngredientSearch.tsx";

const modalBody = css`
  height: 660px;
  padding: 0;
`;

export const IngredientSearchModal = ({
  actionIcon,
  actionLabel,
  defaultTab = "ingredients",
  genericActionLabel = undefined,
  onClose,
  onCreateFromGeneric = undefined,
  onCreateIngredient = undefined,
  onSelect,
  open,
  title,
}: {
  readonly actionIcon: ReactNode;
  readonly actionLabel: string;
  readonly defaultTab?: SearchTab;
  readonly genericActionLabel?: string;
  readonly onClose: () => void;
  readonly onCreateFromGeneric?: (generic: GenericIngredientFragment) => void;
  readonly onCreateIngredient?: () => void;
  readonly onSelect: (item: SearchItem) => void;
  readonly open: boolean;
  readonly title: string;
}) => (
  <Modal
    classNames={{ body: modalBody }}
    destroyOnHidden
    footer={null}
    onCancel={onClose}
    open={open}
    title={title}
    width={960}
  >
    <IngredientSearch
      actionIcon={actionIcon}
      actionLabel={actionLabel}
      defaultTab={defaultTab}
      genericActionLabel={genericActionLabel}
      onCancel={onClose}
      onCreateFromGeneric={onCreateFromGeneric}
      onCreateIngredient={onCreateIngredient}
      onSelect={onSelect}
    />
  </Modal>
);
